import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-subscription-owner-plan',
  templateUrl: './subscription-owner-plan.component.html',
  styleUrls: ['./subscription-owner-plan.component.css']
})
export class SubscriptionOwnerPlanComponent implements OnInit {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  planFeatures = null;
  isDiscountModal: any = false
  discountErrorMessage = "";
  ownerPlanFeatures = {
    data: {
      plan_name: "Owners Plan",
      discount_text: "Get 90% off now! Subscribe and save big",
    },
    standard: {
      plan_id: 1,
      original_price: 475,
      price: 475,
      planName: "Standard Plan",
      features: [
        { label: "Plan validity", value: "60 Days" },
        { "label": "Relationship manager assistance", "value": "" },
        // { "label": "Number of contact details per property", "value": "25" },
        { "label": "Maximum number of properties which can be posted", "value": "3" },
        { label: "", value: "" },
        { label: "", value: "" },
        { label: "", label2: " &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp; ", value: "" },
        { label: "", value: "" },
        { label: "", value: "" },
        { label: "", value: "" },
      ]
    },
    premium: {
      plan_id: 2,
      original_price: 875,
      price: 875,
      planName: "Premium Plan",
      features: [
        { "label": "Plan validity", "value": "100 Days" },
        { "label": "Dedicated relationship manager", "value": "" },
        // { "label": "Number of contact details per property", "value": "Unlimited" },
        { "label": "Maximum number of properties which can be posted", "value": "5" },
        { "label": "Show property on your behalf", "value": "" },
        { "label": "Photoshoot", "value": "" },
        { "label": "Property registration and transfer assistance", "value": "" },
        { "label": "Choice to maintain privacy of the contact details (end to end service by direkt team)", "value": "" },
        { "label": "Documentation (standard govt charges apply)", "value": "" },
        { "label": "Instant property alerts on SMS/WhatsApp", "value": "" }
      ]
    }
  }

  tenantPlanFeatures = {
    data: {
      plan_name: "Tenant Plan",
      discount_text: "Get 90% off now! Subscribe and save big"
    },
    standard: {
      plan_id: 3,
      original_price: 475,
      price: 475,
      planName: "Standard Plan",
      features: [
        { label: "Plan validity", value: "30 Days" },
        { "label": "Number of units/property", "value": "Up to 25" },
        { "label": "Instant property alerts on SMS/WhatsApp", "value": "" },
        { "label": "", "value": "" },
      ]
    },
    premium: {
      plan_id: 4,

      original_price: 875,
      price: 875,
      planName: "Premium Plan",
      features: [
        { label: "Plan validity", value: "60 Days" },
        { "label": "Number of units/property", "value": "Up to 50" },
        { "label": "Dedicated relationship manager", "value": "" },
        { "label": "Instant property alerts on SMS/WhatsApp", "value": "" }
      ]
    }
  }

  buyerPlanFeatures = {
    data: {
      plan_name: "Buyer Plan",
      discount_text: "Get 90% off now! Subscribe and save big"
    },
    standard: {
      plan_id: 5,

      original_price: 475,
      price: 475,
      planName: "Standard Plan",
      features: [
        { label: "Plan validity", value: "30 Days" },
        { "label": "Number of units/property", "value": "Up to 25" },
        { "label": "Mortgage advisory assistance", "value": "" },
        { "label": "Relationship manager assistance", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
      ]
    },
    premium: {
      plan_id: 6,

      original_price: 875,
      price: 875,
      planName: "Premium Plan",
      features: [
        { label: "Plan validity", value: "60 Days" },
        { "label": "Number of units/property", "value": "Up to 50" },
        { "label": "Mortgage advisory assistance", "value": "" },
        { "label": "Dedicated relationship manager", "value": "" },
        { "label": "End of end viewing coordination", "value": "" },
        { "label": "Property registration and transfer assistance", "value": "" },
        { "label": "Choice to maintain privacy of the contact details", "value": "" },
        { "label": "Instant property alerts on SMS/WhatsApp", "value": "" }
      ]
    }
  }
  currentPlanId: any;
  discountCode: any;

  constructor(public shared: SharedService, public apiService: ApiServiceService, private route: ActivatedRoute) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit() {
    // Get the current route path
    if (this.route.snapshot.url && this.route.snapshot.url[0]) {
      switch (this.route.snapshot.url[0].path) {
        case "subscription-owner-plan":
          this.planFeatures = this.ownerPlanFeatures;
          break;
        case "subscription-buyer-plan":
          this.planFeatures = this.buyerPlanFeatures;
          break;
        case "subscription-tenant-plan":
          this.planFeatures = this.tenantPlanFeatures;
          break;

      }
    }
    console.log('Current route path:', this.route.snapshot.url);
  }

  closeModal() {
    setTimeout(() => {
      $('#discountModal').modal('hide');
    });
  }

  async onSubmit(data: any) {
    if (!this.shared.isUserLoggedIn) {
      this.shared.fromButtonLogin = true;
    } else {
      this.isDiscountModal = true;
      this.currentPlanId = data.plan_id;
      setTimeout(() => {
        $('#discountModal').modal('show');
      });
    }
  }

  async applyDiscount() {
    this.discountErrorMessage = "";
    if (!this.discountCode) {
      this.discountErrorMessage = "Discount code is missing";
      return;
    }

    let selectedPlan = this.getPlanById(this.currentPlanId);
    if (!selectedPlan) {
      this.discountErrorMessage = "Invalid Plan ID";
      return;
    }

    let amount = selectedPlan.price;

    this.shared.isLoader = true;
    let discountResponse = await this.apiService.POST_apiRequest(configuration.ENDPOINT.VALIDATE_DISCOUNT, {
      discount_code: this.discountCode,
      amount: amount
    });

    if (discountResponse && discountResponse.data && discountResponse.data) {
      console.log("Discount applied successfully");
      this.redirectToPayment();
    } else {
      console.error("Invalid or missing discount response");
      this.discountErrorMessage = discountResponse && (discountResponse.message ? discountResponse.message : "Please try again")
    }
    this.shared.isLoader = false;
  }

  getPlanById(planId: number) {
    let allPlans = [
      this.ownerPlanFeatures.standard,
      this.ownerPlanFeatures.premium,
      this.tenantPlanFeatures.standard,
      this.tenantPlanFeatures.premium,
      this.buyerPlanFeatures.standard,
      this.buyerPlanFeatures.premium
    ];

    return allPlans.find(plan => plan.plan_id === planId);
  }



  proceedWithoutCoupon() {
    this.redirectToPayment();
  }

  async redirectToPayment() {
    if (!this.currentPlanId) {
      console.error("Plan ID is missing");
      return;
    }

    this.shared.isLoader = true;
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_SESSION, {
      discount_code: this.discountCode,
      plan_id: this.currentPlanId,
    });

    console.log("res", res);
    if (res && !res.error && res.data && res.data.order && res.data.order.url) {
      window.location.href = res.data.order.url;
    }
    this.shared.isLoader = false;
  }
}
